<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.company_request_details") }}</h4>
    </div>
    <!-- End:: Title -->
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <v-row>
            <v-col cols="12">
              <h5 style="color: #724c80" class="font-weight-bold">
                {{ $t("PLACEHOLDERS.summaryData") }}
              </h5>
              <div class="preview-container text-center my-3">
                <h6 style="color: #724c80">
                  {{ $t("PLACEHOLDERS.logo") }}
                </h6>
                <img
                  v-if="data.image.path"
                  col="12"
                  :src="data.image.path"
                  :alt="$t('PLACEHOLDERS.user_image')"
                />
              </div>
            </v-col>
          </v-row>
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.company_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Name Input -->
          <!-- start phone tel -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.phone"
            disabled
          />

          <!-- end phone tel -->
          <!-- Start:: email Input -->
          <base-input
            col="12"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            type="email"
            disabled
          />
          <!-- End:: email Input -->

          <!-- Start:: about_company Input -->
          <base-input
            col="12"
            :placeholder="$t('PLACEHOLDERS.about_company')"
            v-model.trim="data.about_company"
            type="textarea"
            disabled
          />
          <!-- End:: about_company Input -->

          <h5 style="color: #724c80" class="font-weight-bold">
            {{ $t("PLACEHOLDERS.about_comp") }}
          </h5>

          <h6 style="color: #724c80" v-if="data.video">
            {{ $t("PLACEHOLDERS.commercal_register") }}
          </h6>
          <div class="col-12">
            <a
              :href="data.commercial_register"
              target="_blank"
              v-if="data.commercial_register"
            >
              <i class="fas fa-eye" style="color: #724c80; font-size: 20px"></i>
              <span class="mx-2 text-dark">{{
                $t("PLACEHOLDERS.show_commerical_register")
              }}</span>
            </a>
          </div>

          <!-- Start:: description Input -->
          <base-input
            col="12"
            rows="4"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc')"
            v-model.trim="data.description"
            disabled
          />
          <!-- End:: description Input -->

          <!-- Start:: company_field Input -->
          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.company_field')"
            v-model.trim="data.fields"
            :optionsList="[]"
            multiple
            disabled
          />
          <!-- End:: company_field Input -->

          <!-- Start:: company_size Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.company_size')"
            v-model.trim="data.company_size"
            type="text"
            disabled
          />
          <!-- End:: company_size Input -->

          <!-- Start:: website Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.website')"
            v-model.trim="data.website"
            type="text"
            disabled
          />
          <!-- End:: website Input -->

          <!-- Start:: foundation_date Input -->
          <base-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.foundation_date')"
            v-model.trim="data.foundation_date"
            type="text"
            disabled
          />
          <!-- End:: foundation_date Input -->

          <h5 style="color: #724c80" class="font-weight-bold">
            {{ $t("PLACEHOLDERS.address") }}
          </h5>

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.areaOrCity')"
            v-model="data.region"
            disabled
          />
          <div style="pointer-events: none">
            <MapComponent
              :lat="parseFloat(data.latitude)"
              :lng="parseFloat(data.longitude)"
            />
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import MapComponent from "@/components/general/MapComponent";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateCity",

  components: {
    UploadsPhotos,
    ChangableMapComponent,
    MapComponent,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      EnRegex: /[\u0600-\u06FF]/,

      // Start:: Data Collection To Send
      data: {
        image: {
          path: "",
          file: "",
        },
        name: null,
        phone: null,
        email: null,
        description: null,
        commercial_register: null,
        region: null,
        latitude: 24.7136,
        longitude: 46.6753,
        company_field: null,
        company_size: null,
        website: null,
        foundation_date: null,
      },

      phones: [],
      days: [],

      mapOptions: {
        zoomControl: false, // Disable the default zoom control
        disableDoubleClickZoom: true, // Disable zooming on double-click
        draggable: false, // Disable dragging the map
        clickableIcons: false, // Disable clickable icons on the map
        // More options can be added if required
      },

      additionalImages: [],
      imgUrls: [],
      main_sections: [],
      sub_sections: [],
      regions: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();

      // if (!this.data.nameAr) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameAr"));
      //   return;
      // } else if (!this.data.nameEn) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.nameEn"));
      //   return;
      // } else {
      //   return;
      // }
    },
    countryChanged(country) {
      this.data.dialCode = country.dialCode;
      this.data.code = country.iso2;
      console.log(country);
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },
    // End:: validate Form Inputs
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImageSalon(selectedImage) {
      this.data.salon_image = selectedImage;
    },
    // End:: Select Upload Image

    data: {
      salon_number: null,
      active: true,
      registered_in_marouf: 0,
      main_section: null,
      sub_section: null,
      region: null,
      latitude: 24.7136,
      longitude: 46.6753,
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `companies/show-application/${this.$route.params.id}`,
        });

        this.data.image.path = res.data.data?.Company?.logo;
        this.data.name = res.data.data?.Company?.name;
        this.data.phone = res.data.data?.Company?.mobile;
        this.data.email = res.data.data?.Company?.email;
        this.data.about_company = res.data.data?.Company?.about_company;
        this.data.description = res.data.data?.Company?.description;
        this.data.fields = res.data.data?.Company?.fields;
        this.data.company_size = res.data.data?.Company?.company_size;
        this.data.website = res.data.data?.Company?.website;
        this.data.foundation_date = res.data.data?.Company?.foundation_date;
        this.data.commercial_register =
          res.data.data?.Company?.commercialRegister;
        this.data.region = res.data.data?.Company?.area?.name;
        this.data.latitude = +res.data.data?.Company?.latLng[0];
        this.data.longitude = +res.data.data?.Company?.latLng[1];
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
};
</script>

<style lang="scss" scoped>
.images {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;

  .image {
    width: 150px;
    height: 150px;
    img {
      object-fit: cover;
      border-radius: 20px;
      width: 100%;
      height: 100%;
    }
  }
}

@media (max-width: 767px) {
  .items {
    > div {
      width: 100%;
    }
  }
}
</style>
